declare global {
  interface Window {
    AppleID?: AppleLoginAuth;
    AwsWafIntegration: {
      getToken: () => Promise<void>;
      hasToken: () => boolean;
    };
    FB?: {
      XFBML: {
        parse: () => void;
      };
      init: (_: unknown) => void;
    };
    __igEmbedLoaded?: () => void;
    _wct: {
      google_tracking_id: string;
      proxy: string;
      uid: string;
    };
    awsWafCookieDomainList: string[];
    braze?: {
      changeUser: Function;
      disableSDK: Function;
      enableSDK: Function;
      getFeatureFlag: (x: string) => { enabled: boolean } | undefined;
      initialize: Function;
      logCustomEvent: Function;
      logPurchase: Function;
      openSession: Function;
    };
    env: Env;
    fbAsyncInit?: () => void;
    fbq: Function;
    instgrm?: {
      Embeds: {
        process: () => void;
      };
    };
    ttq: {
      track: Function;
    };
    twq: Function;
  }

  namespace NodeJS {
    interface ProcessEnv {
      BRAZE_API_KEY_DE: string;
      BRAZE_API_KEY_GB: string;
    }
  }
}

export type AppleLoginAuth = {
  auth: {
    signIn: () => Promise<{ authorization: { id_token: string } }>;
  };
};

export type Env = {
  ADYEN_ENV: 'live' | 'test';
  ADYEN_KEY: string;
  ALGOLIA_API_KEY: string;
  ALGOLIA_APP_ID: string;
  ALGOLIA_LEGACY_INDEX: string;
  ALGOLIA_PRODUCTS_INDEX: string;
  APPLE_CLIENT_ID: string;
  APPLE_STORE_URL: string;
  APP_NUM_OF_RATINGS: string;
  APP_RATING: string;
  APP_RATINGS_LAST_UPDATED: string;
  BRAZE_BASE_URL: string;
  BRAZE_SDK_API_KEY: string;
  COOKIES_DOMAIN: string;
  FACEBOOK_APP_ID: string;
  FACEBOOK_PIXEL_ID: string;
  FACEBOOK_PIXEL_TOKEN: string;
  FF_INTERNATIONAL_HEADERS: boolean;
  FF_INTERNATIONAL_HOMEPAGE: boolean;
  FF_PLP_PAID_BANNER: boolean;
  FF_PLP_PAID_SPLASH: boolean;

  GA_TRACKING_ID: string;
  GOOGLE_LOGIN_CLIENT_ID: string;
  GTM_AUTH_DE: string;
  GTM_AUTH_GB: string;
  GTM_CONTAINER_ID_DE: string;
  GTM_CONTAINER_ID_GB: string;
  GTM_PREVIEW_DE: string;
  GTM_PREVIEW_GB: string;
  IS_PRODUCTION: boolean;
  SENTRY_DSN: string;
  SITE_BASE_URL: string;
  SUB_DOMAIN?: string;
};

export type PAGE_POSITIONS =
  | 'Banner'
  | 'Gating Card'
  | 'Body'
  | 'Lifestyle News Discover More'
  | 'Dynamic Product Block'
  | 'Filter Toolbar'
  | 'Lifestyle News Small Product Card Grid'
  | 'Header'
  | 'Homepage'
  | 'Homepage App Banner'
  | 'Homepage Hot Deals'
  | 'Homepage Latest News'
  | 'Homepage Popular Brands'
  | 'Homepage Splash'
  | 'Homepage Top Categories'
  | 'Homepage Marketplace'
  | 'Homepage Top Silhouettes'
  | 'Homepage Upcoming Releases'
  | 'Homepage USPs'
  | 'Homepage Whats Hot'
  | 'Image'
  | 'Image Grid'
  | 'Modal'
  | 'More Colours'
  | 'PDP Carousel'
  | 'Product Carousel'
  | 'Product Grid'
  | 'PLP Direct Carousel'
  | 'PLP Main List'
  | 'PLP Popular Carousel'
  | 'PLP Quick Buy'
  | 'PLP Recommendations'
  | 'Product Card'
  | 'Profile Notifications'
  | `Sale Product List-${number}`
  | `Sale Products Highlight-${number}`
  | 'Sale Page Splash'
  | 'Seller Selection'
  | 'Sign in modal'
  | 'Size Selection'
  | 'Sticky CTA'
  | 'Top Bar'
  | 'WTB';

export const REGISTRATION_INTERNAL_SOURCES: Record<string, string> = {
  default: '-',
  like: 'Wishlist',
  restock: 'Notify Me Modal'
};

export type PageType =
  | 'contact'
  | 'homepage'
  | 'news-article'
  | 'pdp'
  | 'plp'
  | 'profile-notifications'
  | 'sales event generic' // Legacy react casing
  | 'single-affiliate-pdp'
  | 'sole-market-listing-selection'
  | 'sole-market-payment'
  | 'sole-market-pdp'
  | 'sole-market'
  | 'unknown';

export type Icon = {
  height: string;
  width: string;
};

export enum OS {
  Android = 'android',
  Linux = 'linux',
  MacOS = 'macOS',
  Unknown = 'unknown',
  Windows = 'windows',
  iOS = 'ios'
}

export type NotificationActionData = {
  expires: number;
  legacyProductId: string;
  productName: string;
  sizes: string[];
};

export type FetcherData = {
  completedAction: string;
  data: { action: string };
  email?: string;
  errors?: {
    authentication: boolean;
    conflict: boolean;
    email: boolean;
    message: string;
    mismatch: boolean;
    notFound: boolean;
    password: boolean;
  };
  success?: boolean;
};
